module.exports = __webpack_public_path__ + "static/media/buffet10.2917afc3.jpg";